<main class="dashboard-task-list-container">
  <mat-card class="dashboard-task-list">
    <mat-card-header class="dashboard-task-header">
      <mat-card-title *ngIf="!activePatient; else patientView"
        >{{ currentUser.firstName + ' ' + currentUser.lastName }}'s Tasks</mat-card-title
      >
      <ng-template #patientView>
        <mat-card-title>Clinical Tasks</mat-card-title>
      </ng-template>

      <form class="task-filter-form" [formGroup]="filterForm">
        <mat-slide-toggle
          *ngIf="activePatient; else providers"
          [checked]="showMyAssignedTasks"
          (change)="onToggleChange($event)"
        >
          Assigned to me
        </mat-slide-toggle>
        <ng-template #providers>
          <div class="task-filter-row">
            <app-provider-selector-list
              class="task-filter-item"
              [label]="'Task Owner'"
              [appearance]="'standard'"
              [providerControl]="filterForm.get('taskOwner')"
              [showAll]="true"
            ></app-provider-selector-list>
          </div>
        </ng-template>
        <mat-form-field>
          <mat-label>Show</mat-label>
          <mat-select formControlName="dateFilter">
            <mat-option *ngFor="let dateSelected of datesOptions" [value]="dateSelected">
              {{ dateSelected.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-button-toggle-group formControlName="taskByState">
          <mat-button-toggle *ngFor="let taskType of tasksByState" [value]="taskType">{{
            taskType.label
          }}</mat-button-toggle>
        </mat-button-toggle-group>
      </form>
      <button
        class="filter"
        *ngIf="!activePatient"
        mat-button
        color="accent"
        matTooltip="Toggle assigned versus owned tasks"
        (click)="toggleAsignedOwned()"
      >
        <mat-icon>filter_alt</mat-icon>
      </button>
      <button mat-button color="accent" (click)="toggleDetail(true)">
        <mat-icon>add_circle_outline</mat-icon>
      </button>
      <mat-card-subtitle *ngIf="!activePatient; else patientViewSub">
        {{ this.assignedView ? 'Assigned Tasks' : 'Owned Tasks' }}
      </mat-card-subtitle>
      <ng-template #patientViewSub>
        <mat-card-subtitle>
          {{ activePatient.firstName + ' ' + activePatient.lastName + ' tasks' }}
        </mat-card-subtitle>
      </ng-template>
      <div mat-card-subtitle *ngIf="!activePatient" class="expand-all-toggle">
        <mat-slide-toggle [checked]="expandAll" (change)="toggleExpandAll($event.checked)">
          Expand All
        </mat-slide-toggle>
      </div>
    </mat-card-header>
    <mat-card-content>
      <div class="task-history-table-container" *ngIf="activePatient">
        <table
          mat-table
          [dataSource]="taskList"
          matSort
          matSortActive="priority_score"
          matSortDirection="desc"
          (matSortChange)="handleSort($event)"
          class="mat-elevation-z4"
          aria-describedby="Tasks list"
        >
          <ng-container matColumnDef="task_name_lower">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              disableClear
              [ngClass]="{ 'sorted-column': currentSortColumn === 'task_name_lower' }"
            >
              Task
            </th>
            <td mat-cell *matCellDef="let clinicalTask">
              <span>{{ clinicalTask.task_name }}</span>
              <div
                *ngIf="clinicalTask.type === 'Missed Call' && clinicalTask.create_date"
                class="missed-call-time"
                [matTooltip]="clinicalTask.create_date | date: 'medium'"
              >
                Received {{ clinicalTask.create_date | date: 'short' }}
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="priority_score">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              disableClear
              [ngClass]="{
                'sorted-column': currentSortColumn === 'priority_score' || currentSortColumn === 'priority'
              }"
            >
              Priority
            </th>
            <td mat-cell *matCellDef="let clinicalTask">
              <mat-chip-list class="small-mat-chip" *ngIf="clinicalTask.priority">
                <mat-chip
                  [color]="getPriorityChipColor(clinicalTask.priority)"
                  [matTooltip]="clinicalTask.priority_reasoning || 'No priority reason provided'"
                  selected
                >
                  {{ clinicalTask.priority | titlecase }}
                </mat-chip>
              </mat-chip-list>
              <span *ngIf="!clinicalTask.priority">N/A</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="category">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="task-history-table-center-header"
              disableClear
              [ngClass]="{ 'sorted-column': currentSortColumn === 'category' }"
            >
              Category
            </th>
            <td mat-cell *matCellDef="let clinicalTask" style="text-align: center">
              <div class="text-center">
                <span>{{ clinicalTask.category ? clinicalTask.category : 'N/A' }}</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="assignee_id" *ngIf="showMyAssignedTasks; else providerCol">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              disableClear
              [ngClass]="{ 'sorted-column': currentSortColumn === 'assignee_id' }"
            >
              Task Owner
            </th>
            <td mat-cell *matCellDef="let clinicalTask">
              {{ clinicalTask.provider.firstName }} {{ clinicalTask.provider.lastName }}
            </td>
          </ng-container>
          <ng-template #providerCol>
            <ng-container matColumnDef="assignee_id">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                disableClear
                [ngClass]="{ 'sorted-column': currentSortColumn === 'assignee_id' }"
              >
                Task Owner
              </th>
              <td mat-cell *matCellDef="let clinicalTask">{{ clinicalTask.assigneeName }}</td>
            </ng-container>
          </ng-template>
          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef>Created By</th>
            <td mat-cell *matCellDef="let clinicalTask">
              {{ clinicalTask.creator_name || clinicalTask.creator_id }}
            </td>
          </ng-container>
          <ng-container matColumnDef="due_date">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              disableClear
              [ngClass]="{ 'sorted-column': currentSortColumn === 'due_date' }"
            >
              Follow Up Date
            </th>
            <td mat-cell *matCellDef="let clinicalTask">
              <mat-icon
                class="due_date-icon"
                *ngIf="clinicalTask?.due_date < datesOptions[0]?.startDate"
                matTooltip="Overdue"
                >warning</mat-icon
              >
              {{ clinicalTask.due_date | date: 'shortDate' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="close">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let clinicalTask" (click)="$event.stopPropagation()">
              <button
                *ngIf="!clinicalTask.completed"
                mat-icon-button
                color="warn"
                matTooltip="Close Task"
                [disabled]="loading"
                (click)="closeTask(clinicalTask)"
              >
                <mat-icon>remove_circle_outline</mat-icon>
              </button>
              <button mat-icon-button color="accent" (click)="editTask(clinicalTask)">
                <mat-icon matTooltip="Edit Clinical Task">edit</mat-icon>
              </button>
              <button mat-icon-button color="accent" (click)="openNotes(clinicalTask)">
                <mat-icon matTooltip="Open Notes">note</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" *ngIf="!loading; else loadingState">No results found</td>
            <ng-template #loadingState>
              <td class="mat-cell">Loading...</td>
            </ng-template>
          </tr>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let clinicalTask; let i = index; columns: displayedColumns"></tr>
        </table>
        <mat-progress-bar *ngIf="loading" mode="indeterminate"> </mat-progress-bar>
      </div>

      <div class="task-history-table-container" *ngIf="!activePatient">
        <table
          mat-table
          [dataSource]="groupedTaskList"
          multiTemplateDataRows
          matSort
          matSortActive="priority_score"
          matSortDirection="desc"
          (matSortChange)="handleSort($event)"
          class="mat-elevation-z4"
          aria-describedby="Tasks list grouped by patient"
        >
          <ng-container matColumnDef="pin">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let group" (click)="$event.stopPropagation()">
              <button
                *ngIf="group.taskCount === 1 && isTaskPinnable(group.tasks[0])"
                mat-icon-button
                color="warn"
                (click)="pinTask(group.tasks[0], $event)"
                [attr.aria-label]="group.tasks[0].pinned ? 'Unpin task' : 'Pin task'"
              >
                <mat-icon *ngIf="group.tasks[0].pinned; else noPinnedGroup" matTooltip="Unpin">push_pin</mat-icon>
                <ng-template #noPinnedGroup>
                  <mat-icon matTooltip="Pin to top" fontSet="material-symbols-outlined">push_pin</mat-icon>
                </ng-template>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="client">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header="client_name_lower"
              disableClear
              [ngClass]="{ 'sorted-column': currentSortColumn === 'client_name_lower' }"
            >
              Client
            </th>
            <td mat-cell *matCellDef="let group">
              <span
                *ngIf="group.patient?.client_responsible_id || group.patient?.client_responsible"
                [matTooltip]="group.patient?.client_responsible"
              >
                {{
                  clientAbbreviations[group.patient?.client_responsible_id] ||
                    (group.patient?.client_responsible | clientAbbreviation)
                }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="patient_name_lower">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              disableClear
              [ngClass]="{ 'sorted-column': currentSortColumn === 'patient_name_lower' }"
            >
              Patient
            </th>
            <td mat-cell *matCellDef="let group">
              <div class="inline-chip">
                <span
                  class="patient-name-badge"
                  [matTooltip]="group.userTags"
                  matTooltipClass="tags-tooltip-theme"
                  matTooltipPosition="below"
                  matBadge="{{ group.taskCount }}"
                  matBadgePosition="before"
                  matBadgeOverlap="true"
                  matBadgeColor="warn"
                  matBadgeSize="small"
                  matBadgeHidden="{{ group.taskCount < 2 }}"
                  >{{ group.patientName }}</span
                >
                <mat-chip-list
                  class="small-mat-chip"
                  *ngIf="group.patient?.isNewPatient"
                  aria-label="New patient"
                  matTooltip="New patient"
                >
                  <mat-chip color="accent" selected>New</mat-chip>
                </mat-chip-list>
                <mat-icon
                  *ngIf="group.hasReleaseAlert"
                  color="warn"
                  class="release-alert-icon"
                  matTooltip="Open Tier 3 vital alert"
                  aria-label="Open Tier 3 vital alert"
                  >notification_important</mat-icon
                >
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="task_name_lower">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              disableClear
              [ngClass]="{ 'sorted-column': currentSortColumn === 'task_name_lower' }"
            >
              Task
            </th>
            <td mat-cell *matCellDef="let group">
              <span *ngIf="group.taskCount === 1; else multipleTask">{{ group.tasks[0]?.task_name }}</span>
              <ng-template #multipleTask>Multiple tasks</ng-template>
            </td>
          </ng-container>
          <!-- Column def stays 'priority_score' because sorting is still driven by the backend
               priority_score field (T12); only the displayed value changed to the patient's
               computedAcuityLevel. -->
          <ng-container matColumnDef="priority_score">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              disableClear
              [ngClass]="{
                'sorted-column': currentSortColumn === 'priority_score' || currentSortColumn === 'priority'
              }"
            >
              Patient Acuity
            </th>
            <td mat-cell *matCellDef="let group">
              <mat-chip-list class="small-mat-chip" *ngIf="group.patient?.computedAcuityLevel">
                <mat-chip [color]="getAcuityChipColor(group.patient?.computedAcuityLevel)" selected>
                  {{ group.patient?.computedAcuityLevel | titlecase }}
                </mat-chip>
              </mat-chip-list>
              <span *ngIf="!group.patient?.computedAcuityLevel">N/A</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="category">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="task-history-table-center-header"
              disableClear
              [ngClass]="{ 'sorted-column': currentSortColumn === 'category' }"
            >
              Category
            </th>
            <td mat-cell *matCellDef="let group" style="text-align: center">
              <div class="text-center" *ngIf="group.taskCount === 1">
                <span>{{ group.tasks[0]?.category ? group.tasks[0]?.category : 'N/A' }}</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="assignee_id">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              disableClear
              [ngClass]="{ 'sorted-column': currentSortColumn === 'assignee_id' }"
            >
              Task Owner
            </th>
            <td mat-cell *matCellDef="let group">
              {{ group.tasks[0]?.provider?.firstName }} {{ group.tasks[0]?.provider?.lastName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef>Created By</th>
            <td mat-cell *matCellDef="let group">
              <ng-container *ngIf="group.taskCount === 1">
                {{ group.tasks[0]?.creator_name || group.tasks[0]?.creator_id }}
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="due_date">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              disableClear
              [ngClass]="{ 'sorted-column': currentSortColumn === 'due_date' }"
            >
              Follow Up Date
            </th>
            <td mat-cell *matCellDef="let group">
              <ng-container *ngIf="group.oldestDueDate">
                <mat-icon
                  class="due_date-icon"
                  *ngIf="group.oldestDueDate < datesOptions[0]?.startDate"
                  matTooltip="Overdue"
                  >warning</mat-icon
                >
                {{ group.oldestDueDate | date: 'shortDate' }}
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="chart">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let group" (click)="$event.stopPropagation()">
              <button
                mat-icon-button
                color="accent"
                matTooltip="View Patient Chart"
                (click)="viewPatient(group.patient_id)"
              >
                <mat-icon>assignment_ind</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="close">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let group" (click)="$event.stopPropagation()">
              <mat-icon
                *ngIf="group.taskCount > 1 && group.hasMissedCall"
                color="accent"
                class="missed-call-icon"
                matTooltip="Missed Call"
                aria-label="Missed Call"
                >phone_missed</mat-icon
              >
              <mat-icon
                *ngIf="group.hasPostHospitalization"
                color="accent"
                class="post-hospitalization-icon"
                matTooltip="Post-hospitalization outreach"
                aria-label="Post-hospitalization outreach"
                >local_hospital</mat-icon
              >
              <ng-container *ngIf="group.taskCount === 1">
                <button
                  *ngIf="!group.tasks[0]?.completed"
                  mat-icon-button
                  color="warn"
                  matTooltip="Close Task"
                  [disabled]="loading"
                  (click)="closeTask(group.tasks[0])"
                >
                  <mat-icon>remove_circle_outline</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="editTask(group.tasks[0])">
                  <mat-icon matTooltip="Edit Clinical Task">edit</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="openNotes(group.tasks[0])">
                  <mat-icon matTooltip="Open Notes">note</mat-icon>
                </button>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let group" [attr.colspan]="groupDisplayedColumns.length">
              <div
                class="task-element-detail"
                [@detailExpand]="expandedGroupPatientIds.has(group.patient_id) ? 'expanded' : 'collapsed'"
              >
                <div class="task-element-description">
                  <table
                    mat-table
                    [dataSource]="group.tasks"
                    class="mat-elevation-z0 nested-task-table"
                    aria-describedby="Tasks for patient"
                  >
                    <ng-container matColumnDef="pin">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let clinicalTask" (click)="$event.stopPropagation()">
                        <button
                          *ngIf="isTaskPinnable(clinicalTask)"
                          mat-icon-button
                          color="warn"
                          (click)="pinTask(clinicalTask, $event)"
                          [attr.aria-label]="clinicalTask.pinned ? 'Unpin task' : 'Pin task'"
                        >
                          <mat-icon *ngIf="clinicalTask.pinned; else noPinned" matTooltip="Unpin">push_pin</mat-icon>
                          <ng-template #noPinned>
                            <mat-icon matTooltip="Pin to top" fontSet="material-symbols-outlined">push_pin</mat-icon>
                          </ng-template>
                        </button>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="task_name_lower">
                      <th mat-header-cell *matHeaderCellDef>Task</th>
                      <td mat-cell *matCellDef="let clinicalTask">
                        <span>{{ clinicalTask.task_name }}</span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="priority_score">
                      <th mat-header-cell *matHeaderCellDef>Priority</th>
                      <td mat-cell *matCellDef="let clinicalTask">
                        <mat-chip-list class="small-mat-chip" *ngIf="clinicalTask.priority">
                          <mat-chip
                            [color]="getPriorityChipColor(clinicalTask.priority)"
                            [matTooltip]="clinicalTask.priority_reasoning || 'No priority reason provided'"
                            selected
                          >
                            {{ clinicalTask.priority | titlecase }}
                          </mat-chip>
                        </mat-chip-list>
                        <span *ngIf="!clinicalTask.priority">N/A</span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="category">
                      <th mat-header-cell *matHeaderCellDef class="task-history-table-center-header">Category</th>
                      <td mat-cell *matCellDef="let clinicalTask" style="text-align: center">
                        <div class="text-center">
                          <span>{{ clinicalTask.category ? clinicalTask.category : 'N/A' }}</span>
                        </div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="assignee_id">
                      <th mat-header-cell *matHeaderCellDef>Task Owner</th>
                      <td mat-cell *matCellDef="let clinicalTask">
                        {{ clinicalTask.provider?.firstName }} {{ clinicalTask.provider?.lastName }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="createdBy">
                      <th mat-header-cell *matHeaderCellDef>Created By</th>
                      <td mat-cell *matCellDef="let clinicalTask">
                        {{ clinicalTask.creator_name || clinicalTask.creator_id }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="due_date">
                      <th mat-header-cell *matHeaderCellDef>Follow Up Date</th>
                      <td mat-cell *matCellDef="let clinicalTask">
                        <mat-icon
                          class="due_date-icon"
                          *ngIf="clinicalTask?.due_date < datesOptions[0]?.startDate"
                          matTooltip="Overdue"
                          >warning</mat-icon
                        >
                        {{ clinicalTask.due_date | date: 'shortDate' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="close">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let clinicalTask" (click)="$event.stopPropagation()">
                        <button
                          *ngIf="!clinicalTask.completed"
                          mat-icon-button
                          color="warn"
                          matTooltip="Close Task"
                          [disabled]="loading"
                          (click)="closeTask(clinicalTask)"
                        >
                          <mat-icon>remove_circle_outline</mat-icon>
                        </button>
                        <button mat-icon-button color="accent" (click)="editTask(clinicalTask)">
                          <mat-icon matTooltip="Edit Clinical Task">edit</mat-icon>
                        </button>
                        <button mat-icon-button color="accent" (click)="openNotes(clinicalTask)">
                          <mat-icon matTooltip="Open Notes">note</mat-icon>
                        </button>
                      </td>
                    </ng-container>
                    <tr
                      mat-row
                      *matRowDef="let clinicalTask; columns: taskDisplayedColumns"
                      [ngClass]="{ 'task-pinned-row': showMyAssignedTasks && clinicalTask.pinned }"
                    ></tr>
                  </table>
                </div>
              </div>
            </td>
          </ng-container>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" *ngIf="!loading; else groupedLoadingState">No results found</td>
            <ng-template #groupedLoadingState>
              <td class="mat-cell">Loading...</td>
            </ng-template>
          </tr>
          <tr mat-header-row *matHeaderRowDef="groupDisplayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let group; columns: groupDisplayedColumns"
            class="task-element-row"
            [class.task-expanded-row]="expandedGroupPatientIds.has(group.patient_id)"
            [class.task-pinned-row]="showMyAssignedTasks && group.hasPinned"
            [class.task-single-row]="group.taskCount === 1"
            [attr.role]="group.taskCount > 1 ? 'button' : null"
            [attr.tabindex]="group.taskCount > 1 ? 0 : null"
            [attr.aria-expanded]="group.taskCount > 1 ? expandedGroupPatientIds.has(group.patient_id) : null"
            (click)="toggleGroup(group)"
            (keydown.enter)="toggleGroup(group)"
            (keydown.space)="$event.preventDefault(); toggleGroup(group)"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: expandedDetailColumns" class="task-detail-row"></tr>
        </table>
        <mat-progress-bar *ngIf="loading" mode="indeterminate"> </mat-progress-bar>
      </div>

      <mat-paginator
        matPaginator
        showFirstLastButtons
        [pageSizeOptions]="[10, 20, 30, 50, 100]"
        [pageSize]="pageSize"
        [length]="totalRecords"
        [pageIndex]="currentPage - 1"
        (page)="changePage($event)"
      ></mat-paginator>
    </mat-card-content>
  </mat-card>
  <div class="dashboard-task-detail" *ngIf="embedDetailNotes && showDetail">
    <app-task-detail [task]="currentTask" (closeDetail)="clearCurrentTask($event)"></app-task-detail>
  </div>
  <div class="dashboard-task-notes" *ngIf="embedDetailNotes && showNotes">
    <app-task-notes [task]="currentTask" (hideComponent)="clearCurrentTask($event)"></app-task-notes>
  </div>
</main>
